import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from '@common/hooks/translation';
import { getCurrencyConfig, maskPlayerName, normalizeAmount } from '../helper';
import Timer from '@common/components/timer';
import depositMoney from '@app/dev/images/deposit-money.png';
import MoneyAmount from '@common/components/moneyAmount';
import Config from "@app/dev/config/main";

export const DepositAmountStep = ({
  form,
  onInactivity,
  timerResetTrigger,
  onClose,
}) => {
  const t = useTranslation();
  const [timer, setTimer] = useState(60);
  const inactivityNotifiedRef = useRef(false);

  const currencyConfig = useMemo(() => getCurrencyConfig(), []);

  useEffect(() => {
    const numericAmount = normalizeAmount(form.amount);
    if (numericAmount > 0) {
      setTimer(60);
      inactivityNotifiedRef.current = false;
    }
  }, [form.amount]);

  useEffect(() => {
    if (
      typeof timer === 'number' &&
      timer <= 10 &&
      timer > 0 &&
      !inactivityNotifiedRef.current
    ) {
      inactivityNotifiedRef.current = true;
      onInactivity?.();
    }
  }, [timer, onInactivity]);

  useEffect(() => {
    if (timerResetTrigger === undefined) return;
    inactivityNotifiedRef.current = false;
    setTimer(60);
  }, [timerResetTrigger]);

  const formattedAmount = useMemo(() => {
    return normalizeAmount(form.amount);
  }, [form.amount]);

  const formattedMaxAmount = useMemo(() => {
    return normalizeAmount(form.maxDepositAmount);
  }, [form.maxDepositAmount]);

  return (
    <>
      {onClose && formattedAmount <= 0 && (
        <i onClick={onClose} className="global-icon icon-Close close-popup" />
      )}
      <p className="popup-title">{t('Deposit')}</p>
      <div className="popup-main-content deposit-section-container">
        <p className="text-center">{t('Please, insert deposit amount')}</p>
        <div className="user-info-container">
          <div className="user-info-box">
            <p className="user-name">{maskPlayerName(form.playerName || 'no name')}</p>
            <p className="user-id">{t('ID')}: <span className="user-id-value">{form.playerId}</span></p>
          </div>
        </div>
        <div className="deposit-amount-container">
          <div className="image-container">
            <img src={depositMoney} alt="deposit amount" />
          </div>
          <p className="inputed-amount">
            <span className="deposit-amount">
              <MoneyAmount config={Config} amount={formattedAmount} currencyConfig={currencyConfig} />
            </span>
          </p>

          {(form.maxDepositAmount || form.maxDepositAmount === 0) ? (
            <p className="deposit-amount-title secondary">
              {t('max deposit amount:')}
              {' '}
              <span className="max-deposit-amount">
                <MoneyAmount config={Config} amount={formattedMaxAmount} currencyConfig={currencyConfig} />
              </span>
            </p>
          ) : null}

        </div>
        <div className="timer-container">
          <Timer
            variant="round"
            duration={60}
            onChange={(value) => {
              const numericValue = typeof value === 'number' ? value : parseInt(value, 10);
              setTimer(Number.isFinite(numericValue) ? numericValue : 0);
            }}
            value={timer}
            onFinish={() => { }}
          />
        </div>
      </div>
    </>
  );
};

